export const ROUTE_PERMISSIONS = {
  "dashboard": "VIEW_DASHBOARD",
  "settings/attributes": "VIEW_ATTRIBUTES",
  "settings/attribute-specs": "VIEW_ATTRIBUTE_SPECS",
  "settings/attribute-value": "VIEW_ATTRIBUTE_VALUES",
  "settings/country": "VIEW_COUNTRY",
  "settings/state": "VIEW_STATE",
  "settings/district": "VIEW_DISTRICT",
  "settings/taluk": "VIEW_TALUK",
  "settings/village": "VIEW_VILLAGE",
  "settings/area": "VIEW_AREA",
  "settings/user": "VIEW_USER_MANAGEMENT",
  "settings/user-subscription": "VIEW_USER_SUBSCRIPTION",
  "settings/property-management": "VIEW_PROPERTY_MANAGEMENT",
  "settings/property-management/add": "ADD_PROPERTY",
  "settings/banner-management": "VIEW_BANNER_MANAGEMENT",
  "settings/help-desk": "VIEW_HELP_DESK",
};
